module.exports = __webpack_public_path__ + "static/media/sbd_logo.973a0334.png";